/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档



export interface API76850Req {
  
  /** (String) */
  bizNo?: string;
    
};



export type API76850Res = boolean;


// 接口函数 76850 任务节点拆分路由true-自动拆分 false-手动拆分

export interface IUseGetAPI76850Return {
  /** 任务节点拆分路由true-自动拆分 false-手动拆分: 接口请求状态 */
  isAPI76850Loading: boolean;
  /** 任务节点拆分路由true-自动拆分 false-手动拆分: 接口请求返回数据 */
  dataAPI76850: API76850Res;
  /**  任务节点拆分路由true-自动拆分 false-手动拆分: 接口数据请求方法 */
  fetchAPI76850Data: (inputs: API76850Req, config?: YWRequestConfig) => Promise<API76850Res>;
  /** 任务节点拆分路由true-自动拆分 false-手动拆分: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI76850 = ():IUseGetAPI76850Return => {
  let isMount = true;
  const [isAPI76850Loading, setIsAPI76850Loading] = useState(false);
  const [dataAPI76850, setDataAPI76850] = useState<API76850Res>({} as API76850Res);
  const requestUrl = `${basePath}/yoaichat-web/task/instance/route/node`;

  const fetchAPI76850Data = async (inputs: API76850Req, config?: YWRequestConfig): Promise<API76850Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API76850Req>) || {}) as API76850Req;
    
  
    if ( isMount ) {
      setIsAPI76850Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API76850Res>(`${basePath}/yoaichat-web/task/instance/route/node?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI76850(res || {} as API76850Res);
        setIsAPI76850Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI76850Loading(false);
      }
      return false as unknown as API76850Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI76850Loading,
    dataAPI76850,
    fetchAPI76850Data,
    requestUrl,
  }
}

